module.exports = __webpack_public_path__ + "static/img/home_4.06294df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_4.png
// module id = n/Sd
// module chunks = 0